import { render, staticRenderFns } from "./Five.vue?vue&type=template&id=63ba1f5a&scoped=true"
import script from "./Five.vue?vue&type=script&lang=js"
export * from "./Five.vue?vue&type=script&lang=js"
import style0 from "./Five.vue?vue&type=style&index=0&id=63ba1f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1f5a",
  null
  
)

export default component.exports